var pestdiseaseapp = angular.module('PestDiseaseApp', [
    'KhBase',
    'highcharts-ng'
]);
